import { LANGUAGES } from 'consts';

export const getLangText = (text: object | string | undefined, defaultLanguage?: string) => {
  if (!text) return null;
  if (typeof text == 'string') return text;

  if (text['__typename']) {
    delete text['__typename'];
  }
  if (text['id']) {
    delete text['id'];
  }

  const languages = LANGUAGES.map((lang) => lang.id);

  const order = defaultLanguage
    ? [defaultLanguage].concat(languages.filter((lang) => lang !== defaultLanguage))
    : languages;

  const sortedObj = Object.keys(text)
    .sort((a, b) => (order.indexOf(a) > order.indexOf(b) ? 1 : -1))
    .reduce((acc, key) => {
      acc[key] = text[key];
      return acc;
    }, {});

  const values: any = Object.values(sortedObj).filter((val) => val !== null) ?? [];

  return values[0] ?? '';
};

export const langHasValue = (text: object | string, languages?: string[]) => {
  if (!text) return false;

  delete text['__typename'];
  delete text['id'];

  if (typeof text == 'object' && languages) {
    return !languages.some((lang) => !text[lang]);
  } else if (typeof text == 'object') {
    return !Object.values(text).some((val) => !val);
  } else {
    return Boolean(text.length);
  }
};

// Cut out new languages for new companies
export const filterLanguages = (languages: string[]) => {
  const baseLanguages = ['se', 'en', 'es', 'no'];
  const newLanguages = languages.filter((language) => baseLanguages.includes(language));

  if (
    languages.some((language) => !baseLanguages.includes(language)) &&
    !newLanguages.includes('se')
  ) {
    newLanguages.push('se');
  }

  return newLanguages;
};
